import { useState } from "react";

import { ProfileCard } from "./ProfileCard";
import { BookingInformationCard } from "./BookingInformationCard";
import { UserInformationCard } from "./UserInformationCard";
import { WebsiteCard } from "./WebsiteCard";
import ChannelsAndAppsNew from "./ChannelsAndAppsNew";
import PrivacySettings from "./PrivacySettings";
import VoiceCloning from "./VoiceCloning";
import { Subscription } from "./subscription/Subscription";
import YourBusinessDescription from "../YourBussiness/YourBusinessDescription";

export default function Settings({ initialTab = "user-info" }) {
  const [activeTab, setActiveTab] = useState(initialTab);

  return (
    <div className="flex w-full min-h-screen bg-[#F5F6FA] px-3 py-3 gap-5">
      <ProfileCard activeTab={activeTab} setActiveTab={setActiveTab} />

      <div className="flex flex-col flex-1 gap-6 overflow-y-auto">
        {activeTab === "user-info" && (
          <>
            <UserInformationCard />
            <YourBusinessDescription />
            <BookingInformationCard />
            <WebsiteCard />
          </>
        )}

        {/* Subscriptions */}
        {/* {activeTab === "subscriptions" && <Subscriptions />} */}

        {/* Voice Cloning */}
        {activeTab === "voice-cloning" && <VoiceCloning />}

        {/* Channels & Apps */}
        {activeTab === "channels" && <ChannelsAndAppsNew />}

        {/* Privacy Settings */}
        {activeTab === "privacy" && <PrivacySettings />}
        {activeTab === "subscription" && <Subscription />}
      </div>
    </div>
  );
}
